import { SetStateAction, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Layout from "../../components/Layout/Layout";
import SigningRequestList from "../../components/SigningRequestList/SigningRequestList";
import { getApplicationVersion } from "../../api/versionApi";
import ErrorMessage from "../../components/ErrorMessage/ErrorMessage";
import { getTextWithCapitalizedFirstLetter } from "../../helpers/textHelper";
import { LAYOUT_TYPE } from "../../constants";
import AndroidIcon from "../../components/AndroidIcon/AndroidIcon";
import LinuxIcon from "../../components/LinuxIcon/LinuxIcon";
import FileContainer from "../../components/FileContainer/FileContainer";

export default function ApplicationVersion() {
  const [applicationVersion, setApplicationVersion] = useState<any>();
  const [error, setError] = useState("");
  const [fileDownloadError, setFileDownloadError] = useState("");
  const params = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    getApplicationVersion(
      Number(params.versionId),
      (responseData: SetStateAction<any>) => {
        setApplicationVersion(responseData);
      },
      (errorText: React.SetStateAction<string>) => {
        setError(errorText);
      }
    );
  }, [params.versionId]);

  if (error) {
    return <ErrorMessage text={error} className="m-5" />;
  }

  return (
    <>
      {fileDownloadError && (
        <ErrorMessage text={fileDownloadError} inContainer={true} />
      )}
      {applicationVersion ? (
        <Layout
          type={LAYOUT_TYPE.INNER_PAGE}
          title={applicationVersion.name}
          backButtonTitle="Application"
          infoFields={[
            {
              icon:
                applicationVersion.platform === "ANDROID" ? (
                  <AndroidIcon />
                ) : (
                  <LinuxIcon />
                ),
              title: getTextWithCapitalizedFirstLetter(
                applicationVersion.platform
              ),
            },
          ]}
          buttons={[
            {
              title: "Create New Signing",
              variant: "primary",
              action: () => {
                navigate(
                  "/application/" +
                    params.applicationId +
                    "/version/" +
                    params.versionId +
                    "/signing/create"
                );
              },
            },
          ]}
        >
          {Object.keys(applicationVersion.file).length > 0 && (
            <FileContainer
              file={applicationVersion.file}
              onFetchError={(errorText: SetStateAction<string>) => {
                setError(errorText);
              }}
              onDownloadError={(errorText: SetStateAction<string>) => {
                setFileDownloadError(errorText);
              }}
            />
          )}
          {params.applicationId && params.versionId && (
            <SigningRequestList
              applicationId={Number(params.applicationId)}
              versionId={Number(params.versionId)}
            />
          )}
        </Layout>
      ) : (
        <Layout type={LAYOUT_TYPE.INNER_PAGE_LOADING} />
      )}
    </>
  );
}
